<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col xl="12">
        <b-card>
          <div slot="header">
            <strong>Resumen de Aperturas/Cierres de Presupuestos Internos</strong>
          </div>
          <b-form>
            <b-form-group
              label="Fecha Desde"
              label-for="fechaDesde"
              :label-cols="labelCols"
              description="Fecha de apertura/cierre del presupuesto interno"
              horizontal>
              <b-form-input 
                id="fechaDesde" 
                v-model= "fechaDesde" 
                type="date">
              </b-form-input>
            </b-form-group>

            <b-form-group
              label="Fecha Hasta"
              label-for="fechaHasta"
              :label-cols="labelCols"
              description="Fecha de apertura/cierre del presupuesto interno"
              horizontal>
              <b-form-input 
                id="fechaHasta" 
                v-model= "fechaHasta" 
                type="date">
              </b-form-input>
            </b-form-group>

            <b-form-group
              label="Cliente"
              label-for="cliente"
              :label-cols="labelCols"
              horizontal>
              <b-input-group>
                <b-input-group-append 
                    class="filter-search-icons" 
                    @click="seleccionarCliente">
                  <b-input-group-text>
                    <i :class="{ 'fa fa-search': !cliente,
                                  'fa fa-remove': cliente  }"></i>
                  </b-input-group-text>
                </b-input-group-append>
                <b-form-input 
                  id="cliente"
                  :value="clienteNombre"
                  readonly
                  type="text"/>
              </b-input-group>
            </b-form-group>

          </b-form>
          <div slot="footer">
            <b-button size="sm" variant="primary" class="footer-button"
              @click.prevent="exportXls">Exportar XLS</b-button>
          </div>
        </b-card>
      </b-col>
    </b-row>

    <b-modal ref="searchClienteModal"
        title="Seleccionar Cliente"
        header-bg-variant= "light" 
        hide-footer
        lazy
        modal-class="clientes-search-modal">
      <app-search-cliente
        :incluirInactivos="true"
        @clienteSeleccionado="clienteSeleccionado">
      </app-search-cliente>  
    </b-modal>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import SearchCliente from '../clientes/SearchList.vue';
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs'
import moment from 'moment';

export default {
  name: 'ABM',
  components: {
    appSearchCliente: SearchCliente,
    appMensaje: Mensaje
  },
  mixins: [
    msjModal, 
  ],
  data () {
    return {
      fechaDesde: moment(new Date()).format('YYYY-MM-DD'),
      fechaHasta: moment(new Date()).format('YYYY-MM-DD'),
      cliente: null,
      numeroPresupuesto: 0,

      labelCols: 2,
    }
  },
  computed: {
    clienteNombre() {
      return this.cliente? this.cliente.nombre.trim() : '';
    },
  },
  created() {
    
  },  
  methods: {
    exportXls () {
      let execute = true;

      /* Antes de intentar registrar por primera vez, no validamos */
      this.noValidar = false;

      let clienteId = 0;
      if (this.cliente) {
        clienteId = this.cliente.id;
      }

      let params = {
        fechaDesde: this.fechaDesde,
        fechaHasta: this.fechaHasta,
        clienteId,
        // numeroPresupuesto: this.numeroPresupuesto
      }

      if (execute) {
        this.showSpinner();
        this.$store.dispatch('presupuestosinternos/getRptAperturasCierres', params)
          .then(() => {
            let exportRpt = Boolean(false); 
            let rptPresupuestos = this.$store.getters['presupuestosinternos/rptAperturasCierres'];

            if (rptPresupuestos) {
              if (rptPresupuestos.length != 0) {
                exportRpt = Boolean(true);
              }
            }
            if (exportRpt) {
              let title= 'Detalle de Aperturas-Cierres';
              let fileName = 'aperturas-cierres';
              let format = [
                { titulo: 'Nro.', nombre: 'presupuestoNumero', formato: '' },
                { titulo: 'Cliente', nombre: 'cliente', formato: '' },
                { titulo: 'Accion', nombre: 'accion', formato: '' },
                { titulo: 'Nro.Orden', nombre: 'numeroOrdenCompra', formato: '' },
                // { titulo: 'Fecha Cierre Estimado', nombre: 'fechaCierreEstimado', formato: 'fecha' },
                { titulo: 'Fecha Movimiento', nombre: 'fechaAperturaCierre', formato: 'fecha' },
                { titulo: 'Movimiento', nombre: 'movimientoAperturaCierre', formato: '' },
                { titulo: 'Usuario', nombre: 'usuarioAperturaCierre', formato: '' },
                { titulo: 'Observaciones', nombre: 'observacionesAperturaCierre', formato: '' }
              ];

              this.exportXLS(title, fileName, rptPresupuestos, format);
            } else {
              console.log('No hay datos para exportar.');
            }
          })
          .catch(error => this.showErrorMsj(error))
          .finally(() => this.hideSpinner());
      }
    },
    // goBack() {

    // },
    seleccionarCliente() {
      if (this.cliente) {
        this.cliente = null;
      } else {
        this.$refs.searchClienteModal.show();
      }
    },
    clienteSeleccionado(item) {
      this.cliente = item;
      this.$refs.searchClienteModal.hide();
    },
  },
}
</script>

<style>
</style>
